import GAME_IDS from 'a/hub/data/GameIds';

export const GAME_ID = GAME_IDS.WORD_RAIDERS;

export const CONTENT_VERSION = '0.0.1';
export const LEVEL_COUNT = 36;
export const MASTERY_REVIEW = 7;
export const MASTERY_STANDARD = 6;
export const QUESTION_COUNT = 8;

export const SCREENS = {
  PROGRESS: 'PROGRESS',
  WORD_MATCH: 'WORD_MATCH',
  WORD_REVIEW: 'WORD_REVIEW',
  WORD_CONTEXT: 'WORD_CONTEXT',
  LOADING: 'LOADING',
};

export const SEARCHLIGHT_DISPATCH_EVENT = 'SEARCHLIGHT_DISPATCH_EVENT';

export const REDUX_ACTIONS = {
  QUICK_ROUND: 'QUICK_ROUND',
  SET_LEVEL: 'SET_LEVEL',
  SET_WORD_STAGE: 'SET_WORD_STAGE',
  ADD_QUESTION: 'ADD_QUESTION',
  RESET_QUESTIONS: 'RESET_QUESTIONS',
};

export const WORD_STAGE = { SYNONYM: 'SYNONYM', ANTONYM: 'ANTONYM' };

// Each review mode set has 4 questions and payoff
export const REVIEW_PHASES = {
  DEFINITION: 0,
  SENTENCE: 1,
  SYNONYM: 2,
  ANTONYM: 3,
};
